import { postData, getData } from "./apiServices";

export const getAllBlogs = async () => {

    const endpoint = 'common/getAllBlogs'
    try {
        const response = await getData(endpoint);
        return response;
    } catch (error) {
        console.error('Signup failed:', error);
        throw error;
    }

}


export const getSEODataList = async () => {

    const endpoint = 'common/getSEODataList'
    try {
        const response = await getData(endpoint);
        return response;
    } catch (error) {
        console.error('Signup failed:', error);
        throw error;
    }

}


export const getBlogById = async (id: number) => {
    const endpoint = `common/getBlogById`;

    const Payload = {
        id: id
    }

    try {
        const response = await postData(endpoint, Payload);
        return response;
    } catch (error) {
        console.error('Signup failed:', error);
        throw error;
    }
};